/* istanbul ignore file */
export { default } from './Header';
